import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult } from '../rules';
import { RulesetEngine } from './RulesetEngine';
import { FeatureType } from '../../../../../../../constants';

export class RulesetProxy implements Ruleset {
  constructor(
    private readonly wrapped: Ruleset,
    private readonly featureType: FeatureType
  ) {}

  // This is a truth table for merging the legacy ruleset result with the engine result.
  // The engine result is a boolean, and the legacy ruleset result is a RulesetResult.
  private mergeResults(
    legacy: RulesetResult,
    engineRequired: boolean
  ): RulesetResult {
    if (!engineRequired) {
      // If the engine says it's not required, and the legacy ruleset says it's required,
      // then we should return REQUIRED since we are forcing the field for some exceptions where we want an answer.
      // Doesn't mean we require a PG
      if (legacy === RulesetResult.REQUIRED) return RulesetResult.REQUIRED;
      return legacy;
    }
    // If the engine says it's required, then we should return REQUIRED.
    return RulesetResult.REQUIRED;
  }

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    // 1) Ask the legacy ruleset what it thinks (REQUIRED/OPTIONAL/HIDDEN).
    const legacyResult = this.wrapped.evaluate(data);

    // 2) Ask the engine if this feature is required for the same payload.
    //    (Synchronous; engine should have been inited at app boot.)
    const engineRequired = RulesetEngine.evaluate(this.featureType, data);

    // 3) Merge via our truth table.
    const result = this.mergeResults(legacyResult, engineRequired);

    return result;
  };
}
